import { capitalizeStringWithUnderscores } from 'utils/helperMethods';
import { FormElems } from '..';
import React from 'react';
import PropTypes from 'prop-types';
// Libraries

import { Field, FieldArray } from 'redux-form';
// Card slabs

const renderSurchargeBankSlab = ({
    fields,
    meta: { error, submitFailed },
    sectionData,
    bankOptions,
    isViewMode,
    sectionName,
    walletOptions,
}) => {
    const newAddFieldInitialData = { bankSlabs: sectionData[0].bankSlabs };
    const selectedSchemes = fields.getAll()?.map(data => data.issuerId) || [];
    const selectedWallets = fields.getAll()?.map(data => data.issuerId) || [];

    // eslint-disable-next-line no-param-reassign
    const filteredBankOptions = bankOptions.filter(
        options => !selectedSchemes.includes(options.value)
    );

    const filteredWalletsOptions = walletOptions.filter(
        options => !selectedWallets.includes(options.value)
    );

    const selectedBank = index => {
        const data = fields.getAll();
        const selectedBankType = data[index].issuerId;
        if (selectedBankType && index !== 0) {
            const selectedOption = bankOptions.find(
                option => option.value === selectedBankType
            );

            return [selectedOption];
        }
        return [];
    };

    const selectedWallet = index => {
        const data = fields.getAll();
        const selectedWalletType = data[index].issuerId;
        if (selectedWalletType && index !== 0) {
            const selectedOption = walletOptions.find(
                option => option.value === selectedWalletType
            );

            return [selectedOption];
        }
        return [];
    };

    return (
        <>
            {fields.map((item, index) => (
                <>
                    {sectionName === 'Net-Banking' && (
                        <div className="bank-wrap">
                            <Field
                                wrapperClass="surcharge-bank"
                                name={`${item}.issuerId`}
                                id={`${item}-issuerId`}
                                component={FormElems.Select}
                                data={
                                    [
                                        ...selectedBank(index),
                                        ...filteredBankOptions,
                                    ] || []
                                }
                                label={index === 0 ? 'All Banks' : 'Add Bank'}
                                labelField="label"
                                valueField="value"
                                disabled={isViewMode || index === 0}
                                borderRadius="5px"
                            />
                            {index > 0 ? (
                                <FormElems.Button
                                    customClass="remove-button"
                                    buttonType="secondary"
                                    id={`remove-${item}-issuerId`}
                                    text="x Remove"
                                    type="button"
                                    isDisable={isViewMode}
                                    handleClick={() => fields.remove(index)}
                                />
                            ) : (
                                <FormElems.Button
                                    customClass="add-button"
                                    buttonType="secondary"
                                    id={`add-${item}-issuerId`}
                                    text="+ Add Bank"
                                    type="button"
                                    isDisable={isViewMode}
                                    handleClick={() =>
                                        fields.push({
                                            ...newAddFieldInitialData,
                                        })
                                    }
                                />
                            )}
                        </div>
                    )}

                    {sectionName === 'Wallets' && (
                        <div className="bank-wrap">
                            <Field
                                wrapperClass="surcharge-bank"
                                name={`${item}.issuerId`}
                                id={`${item}-issuerId`}
                                component={FormElems.Select}
                                data={
                                    [
                                        ...selectedWallet(index),
                                        ...filteredWalletsOptions,
                                    ] || []
                                }
                                label={
                                    index === 0 ? 'All Wallets' : 'Add Wallets'
                                }
                                labelField="label"
                                valueField="value"
                                disabled={isViewMode || index === 0}
                                borderRadius="5px"
                            />
                            {index > 0 ? (
                                <FormElems.Button
                                    customClass="remove-button"
                                    buttonType="secondary"
                                    id={`remove-${item}-issuerId`}
                                    text="x Remove"
                                    type="button"
                                    isDisable={isViewMode}
                                    handleClick={() => fields.remove(index)}
                                />
                            ) : (
                                <FormElems.Button
                                    customClass="add-button"
                                    buttonType="secondary"
                                    id={`add-${item}-issuerId`}
                                    text="+ Add Wallet"
                                    type="button"
                                    isDisable={isViewMode}
                                    handleClick={() =>
                                        fields.push({
                                            ...newAddFieldInitialData,
                                        })
                                    }
                                />
                            )}
                        </div>
                    )}

                    <ul className="slabCard-container border-bottom">
                        <FieldArray
                            name={`${item}.bankSlabs`}
                            component={renderBankSlabItems}
                            bankOptions={bankOptions}
                            props={{ sectionData, isViewMode }}
                            sectionName={sectionName}
                        />
                    </ul>
                </>
            ))}
        </>
    );
};

// card slabs
const renderBankSlabItems = ({
    fields,
    meta: { error, submitFailed },
    sectionData,
    isViewMode,
    sectionName,
}) => {
    // const section = sectionData.length > 0 ? sectionData : [];
    // eslint-disable-next-line react/prop-types
    const section = fields.getAll();
    // if lower slab <=2000 and higher lab is null
    const noSlab = section.find(item => {
        return (
            item.lowerSlab !== null && item.lowerSlab < 2000 && !item.higherSlab
        );
    });

    const cardTitle = title => {
        if (title === 'ESF') {
            return 'SAME DAY SETTLEMENT FEE';
        }

        return title === 'ODS' ? 'ODS FEE' : title?.replaceAll('_', ' ');
    };

    const tiles = (item, index) => {
        return (
            <li className={!noSlab ? 'cardTile' : ''}>
                <div className="slab-title">
                    <div className="title">
                        {`${cardTitle(section[index]?.type)} ${
                            sectionName === 'UPI'
                                ? `for ${capitalizeStringWithUnderscores(
                                      section[index].accountType
                                  )}`
                                : ''
                        }  `}
                    </div>
                </div>
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">Percent</p>
                        <Field
                            name={`${item}.feePercent`}
                            id={`${item}-feePercent`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="%"
                            postfixContent="%"
                            disabled={isViewMode}
                            borderRadius="5px"
                            maxDecimals={4}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Flat</p>
                        <Field
                            name={`${item}.feeFlat`}
                            id={`${item}-feeFlat`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="INR"
                            disabled={isViewMode}
                            maxDecimals={2}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Criteria</p>
                        <Field
                            name={`${item}.feeCriteria`}
                            id={`${item}-feeCriteria`}
                            data={[
                                {
                                    label: 'Minimum',
                                    value: 'MINIMUM',
                                },
                                {
                                    label: 'Maximum',
                                    value: 'MAXIMUM',
                                },
                                {
                                    label: 'Both',
                                    value: 'BOTH',
                                },
                            ]}
                            labelField="label"
                            valueField="value"
                            component={FormElems.Select}
                            label="Criteria"
                            disabled={isViewMode}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Tax</p>
                        <Field
                            name={`${item}.tax`}
                            id={`${item}-tax`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="%"
                            postfixContent="%"
                            disabled={isViewMode}
                            borderRadius="5px"
                            maxDecimals={2}
                        />
                    </div>
                </div>
            </li>
        );
    };

    const renderSlabs = () => {
        // get left slabs
        // eslint-disable-next-line array-callback-return
        const leftSlab = fields.map((item, index) => {
            if (
                section[index].higherSlab &&
                section[index].higherSlab <= 2000
            ) {
                return tiles(item, index);
            }
        });

        // get right slabs
        // eslint-disable-next-line array-callback-return
        const rightSlab = fields.map((item, index) => {
            if (section[index].lowerSlab && section[index].lowerSlab >= 2000) {
                return tiles(item, index);
            }
        });

        return (
            <>
                <ul className="leftSlab-container slabCard-container slab">
                    <div className="slab-heading">Slab - Upto 2000 </div>
                    {leftSlab}
                </ul>
                <ul className="rightSlab-container slabCard-container slab">
                    <p className="slab-heading">Slab - Above 2000 </p>
                    {rightSlab}
                </ul>
            </>
        );
    };

    if (noSlab) {
        return fields.map((item, index) => {
            return tiles(item, index);
        });
    }
    return <div style={{ display: 'flex' }}>{renderSlabs()}</div>;
};

renderSurchargeBankSlab.propTypes = {
    fields: PropTypes.object.isRequired,
    meta: PropTypes.object,
    sectionData: PropTypes.object,
    bankOptions: PropTypes.array,
    isViewMode: PropTypes.bool,
    sectionName: PropTypes.string,
    walletOptions: PropTypes.array,
};
renderBankSlabItems.propTypes = {
    fields: PropTypes.object.isRequired,
    meta: PropTypes.object,
    sectionData: PropTypes.object,
    bankOptions: PropTypes.array,
    isViewMode: PropTypes.bool,
    sectionName: PropTypes.string,
};

export default renderSurchargeBankSlab;
